import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const inventoryEventCountWidget: DashboardWidgetConfiguration = {
  widgetId: "inventory.event-count",
  name: "Stock movements",
  description: "Stock movements for the selected dashboard period.",
  apps: [
    "home",
    "inventory",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "inventory.stock-events",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "event_id",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Movements",
    subtext: "in the last 30 days",
    icon: "orders",
    color: "primary",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 186,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
